import { setIsUserCriticalAction } from '@wildberries/databus-service-user';
import { getMfaState } from '@/_utils/init-app-utils/requests-proxy/init-request-proxy-verify/_utils/ get-mfa-state';
import { criticalAction } from '@/_utils/init-app-utils/requests-proxy/init-request-proxy-verify/_utils/critical-action';
import { getDeviceIdForCritAction } from './get-device-id-for-crit-action';

export const confirmationCriticalAction = async ({
  retryRequest,
  isCriticalAction,
}: {
  retryRequest: any;
  isCriticalAction: boolean;
}) => {
  const deviceId = getDeviceIdForCritAction();
  try {
    setIsUserCriticalAction(isCriticalAction);
    await getMfaState(deviceId)
      .then(({ sticker }: { sticker: string }) => {
        criticalAction({ retryRequest, sticker, deviceId });
      })
      .catch((error) => {
        throw new Error(error);
      });
  } catch {
    return false;
  }
};
